import http from '../core/http-common'
import { IDesk } from '../types/DeskType'
import { ITransactionResponse } from '../types/MainType'

class DeskService {
  getDesk(floorId: number) {
    return http.get<IDesk[]>(`/Desk?floorId=${floorId}`)
  }

  getDeskList(floorId: number) {
    return http.get<IDesk[]>(`/Desk/GetDeskList?floorId=${floorId}`)
  }

  createDesk(desk: IDesk) {
    return http.post<ITransactionResponse>('/Desk/SaveDesk', desk)
  }

  deleteDesk(desk: IDesk) {
    return http.post<ITransactionResponse>('/Desk/DeleteDesk', desk)
  }
}

export default new DeskService()
